import { cn } from '@makyoapp/makyo-tw-ui'

import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useUpdateCompSettings, useUpdateCompSettingValue } from '@/hooks/useUpdateCompSettings'
import { BuilderComponentSetting, FlattenedItem } from '@/shared/builder'
import { hasResponsiveSettings } from '@/shared/builder/viewport/responsive-settings'

interface SegmentedSelectFieldSettingProps {
  id: string
  segmentedSelectSettings: BuilderComponentSetting['segmentedSelectSettings']
  ancestors: FlattenedItem[]
  settingId: string
  value: any
}

const SegmentedSelectFieldSetting = ({
  segmentedSelectSettings,
  ancestors,
  settingId,
  id,
  value,
}: SegmentedSelectFieldSettingProps) => {
  const { activeComponent } = useActiveLayerContext()
  const updateSettings = useUpdateCompSettings()
  const updateValue = useUpdateCompSettingValue(id)

  const { options = [] } = segmentedSelectSettings ?? {}

  const rawOptions = (typeof options === 'function' ? options(activeComponent?.id || '', ancestors) : options) || []

  // Pastikan value sesuai dengan format yang diharapkan (string)
  const currValue = typeof value === 'undefined' || value === null ? '' : value.toString()

  const handleClick = async (optValue: string | number) => {
    const selectedOption = rawOptions.find((opt) => opt.value.toString() === optValue.toString())
    const newValue = selectedOption ? selectedOption.value : optValue

    if (hasResponsiveSettings(id)) {
      await updateValue(newValue)
    } else {
      await updateSettings((prevSettings) => {
        prevSettings[id] = newValue
      })
    }
  }

  return (
    <div className='flex items-center gap-0 bg-zinc-100 dark:bg-slate-800 rounded-lg p-1 w-full overflow-hidden'>
      {rawOptions.map((opt) => {
        const isSelected = opt.value.toString() === currValue
        return (
          <button
            key={opt.value}
            type='button'
            onClick={() => handleClick(opt.value)}
            className={cn(
              'flex-1 min-w-0 px-2 py-2 rounded-md text-[10px] font-medium transition-all duration-200 text-center truncate',
              isSelected
                ? 'bg-white dark:bg-slate-700 text-zinc-900 dark:text-white shadow-sm'
                : 'text-zinc-600 dark:text-slate-400 hover:text-zinc-900 dark:hover:text-white'
            )}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}

export default SegmentedSelectFieldSetting
